var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('order-summary-item',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"boarding-info__name"},[_vm._v("\n    "+_vm._s(_vm.$t(`common.boarding.${_vm.boarding}`))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }